export const ACCOUNT_PAGE_TITLE = 'Account';
export const ACCOUNT_PAGE_DESCRIPTION = 'Advanced users only! These tokens are only needed if you want to write your own API integration.';
export const API_KEY_TITLE = 'API Key';
export const SECRET_KEY_TITLE = 'Secret Key';
export const MASTER_ADDRESSES_TITLE = 'Master Addresses';
export const MASTER_ADDRESSES_DESC = 'Your Master Address will be used to replenish wallet balance and conduct transactions in the system. Each cryptocurrency uses its own wallet.';
